export default (prevState = {}, action)=> {
  switch (action.type) {

  default:
    return prevState;

  }
};

export const getSamlIntegrations = (state)=>
  state.samlIntegrations;
